import { Link } from "@tanstack/react-router";
import { LogOut, Share2, Shield, Trash2 } from "lucide-react";
import { useTranslation } from "react-i18next";

import { logout } from "@/auth/login";
import { useAuth } from "@/auth/stub";
import { Logo } from "@/components/Logo";
import { NotificationsBell } from "@/components/NotificationsBell";
import { Button } from "@/components/ui/button";
import { useAppName } from "@/lib/branding";

export function TopBar() {
  const { t } = useTranslation();
  const appName = useAppName();
  const user = useAuth((s) => s.user);

  return (
    <header className="flex items-center justify-between border-b px-4 py-2 bg-background">
      <div className="flex items-center gap-3">
        <Link
          to="/"
          className="flex items-center gap-2 text-base font-semibold hover:underline"
        >
          <Logo className="h-6 w-6" />
          {appName}
        </Link>
        {user && (
          <>
            <Link
              to="/shared-with-me"
              className="flex items-center gap-1 text-sm text-muted-foreground hover:text-foreground"
            >
              <Share2 className="h-4 w-4" aria-hidden />
              {t("nav.shared_with_me", "Shared with me")}
            </Link>
            <Link
              to="/trash"
              className="flex items-center gap-1 text-sm text-muted-foreground hover:text-foreground"
            >
              <Trash2 className="h-4 w-4" aria-hidden />
              {t("nav.trash", "Trash")}
            </Link>
          </>
        )}
      </div>
      {user && (
        <div className="flex items-center gap-3 text-sm">
          <span className="text-muted-foreground">{user.email}</span>
          {user.is_admin && (
            <Link
              to="/admin"
              className="rounded-sm bg-primary/10 px-2 py-0.5 text-xs text-primary hover:underline"
            >
              {t("nav.admin_badge", "admin")}
            </Link>
          )}
          <NotificationsBell />
          {/* asChild: one interactive element (a link styled as a
              button), not a <button> nested inside an <a>. */}
          <Button asChild variant="ghost" size="sm">
            <Link to="/security" aria-label={t("nav.security", "Security")}>
              <Shield className="h-4 w-4" aria-hidden />
            </Link>
          </Button>
          <Button
            variant="ghost"
            size="sm"
            onClick={() => {
              void logout();
            }}
            aria-label={t("auth.logout", "Log out")}
          >
            <LogOut className="h-4 w-4" aria-hidden />
          </Button>
        </div>
      )}
    </header>
  );
}
